import axios from "axios";
import { HISTORIAN_SERVICE_BASE } from '../constants';
import { getHeaders } from './AuthService';
import { getPointsForEquipment } from "./MetadataService";

/**
 * @deprecated This call is problematic and will be deprecated eventually. 
 *             Also the telemetry->graph code is a bit of an inefficient 
 *             mess.
 * @see getTimeSeriesDataForEquipment
 */
export const getTimeSeriesData = async (siteId, equipmentId, startDateTime, endDateTime) => {
  let results = await axios.get(`${HISTORIAN_SERVICE_BASE()}/history/telemetry/site/${siteId}/equipment/${equipmentId}?start=${startDateTime.toISOString()}&end=${endDateTime.toISOString()}`, 
      { headers: await getHeaders() })
  return results.data;
};

/**
 * Fetches active points for equipment, and then fan-outs to get the time series 
 * data for the equipment's active, graphed points. It combines and flattens the
 * response to match the signature of the deprecated getTimeSeriesData call.
 * @see getTimeSeriesData
 */
export const getTimeSeriesDataForEquipment = async (siteId, equipmentId, startDateTime, endDateTime, freq, aggregate) => {
  const activePoints = await getPointsForEquipment(equipmentId, true)
  const graphedPoints = activePoints.filter(point => point.is_graphed && point.uuid != null)
  const pointTimeSeries = await Promise.all(graphedPoints.map(async (point) => {
    const pointTimeSeries = await getTimeSeriesDataForPoint(siteId, point.uuid, startDateTime, endDateTime, freq, aggregate)
    return pointTimeSeries.map(telemetryDataPoint => ({
      point_uuid: point.uuid,
      point_name: point.name,
      ...telemetryDataPoint,
    }))
  }))
  return pointTimeSeries.reduce((acc, val) => acc.concat(val), [])
};

export const getTimeSeriesDataForPoint = async (siteId, pointId, startDateTime, endDateTime, freq, aggregate = 'mean') => {
  try {
    let results = await axios.get(`${HISTORIAN_SERVICE_BASE()}/history/telemetry/site/${siteId}/point/${pointId}?start=${startDateTime.toISOString()}&end=${endDateTime.toISOString()}&freq=${freq}&aggregate=${aggregate}`, 
      { headers: await getHeaders() })
    return results.data;
  } catch (e) {
    if (e.response?.status === 500) {
      // the backend is currently exploding when it gets a request with an interval, fall back to no interval until
      // it is fixed or works differently.
      let results = await axios.get(`${HISTORIAN_SERVICE_BASE()}/history/telemetry/site/${siteId}/point/${pointId}?start=${startDateTime.toISOString()}&end=${endDateTime.toISOString()}`, 
        { headers: await getHeaders() })
      return results.data;
    } else {
      throw e;
    }
  }
}

export const getCVTData = async (siteId, equipmentId) => {
  let results = await axios.get(`${HISTORIAN_SERVICE_BASE()}/history/telemetry/cvt/site/${siteId}/equipment/${equipmentId}`,
      { headers: await getHeaders() })
  return results.data;
};
